import {
  FACET_URL_PARAMS,
  FACET_URL_PATH,
  REMOVE_PERSONALIZED_SIZE,
  RESET_FACET_GROUP,
  TOGGLE_PERSONALIZED_SIZE,
  TOGGLE_SELECTED_FACET,
  TOGGLE_SELECTED_FACET_GROUP
} from 'constants/reduxActions';
import { FOO_URL, getQueryStringParams } from 'helpers/SearchUtils';

export function resetFacetGroup(facetField) {
  return {
    type: RESET_FACET_GROUP,
    facetField
  };
}

export function toggleSelectedFacetGroup(selectedFacetGroupName, section) {
  return {
    type: TOGGLE_SELECTED_FACET_GROUP,
    selectedFacetGroupName,
    section
  };
}

export function toggleSelectedFacet(facetGroup, facetName, selectedFacetGroupIndex, selectedFacetIndex, section, isSingleSelect) {
  return {
    type: TOGGLE_SELECTED_FACET,
    facetGroup,
    facetName,
    selectedFacetIndex,
    selectedFacetGroupIndex,
    section,
    isSingleSelect
  };
}

export function getFacetUrlParams(string) {
  const params = getQueryStringParams(string);
  return {
    type: FACET_URL_PARAMS,
    facetUrlQueryParams: params
  };
}

export function getFacetUrlPath(string) {
  const { pathname } = new URL(string, FOO_URL);
  return {
    type: FACET_URL_PATH,
    facetUrlPath: pathname
  };
}

export function togglePersonalizedSize(response) {
  return {
    type: TOGGLE_PERSONALIZED_SIZE,
    response
  };
}

export function removePersonalizedSize() {
  return {
    type: REMOVE_PERSONALIZED_SIZE
  };
}
